import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import iView from 'iview'
import inject from './plugins/inject'
import decorate from './plugins/decorate'
import ElementUI from 'element-ui'
import Clipboard from 'v-clipboard'
import 'element-ui/lib/theme-chalk/index.css'
import 'iview/dist/styles/iview.css'
import '@/assets/css/iconfont/iconfont.css'
import '@/assets/css/normallize/normallize.css'

Vue.use(router)
Vue.use(iView)
Vue.use(ElementUI)
Vue.use(inject)
Vue.use(decorate)
Vue.use(Clipboard)
// localStorage.setItem('token','eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiJCZXoyMDE4MDEyMyIsInNjb3BlIjpbInVzZXJfaW5mbyJdLCJ0ZW5hbnRfZG9tYWluIjpudWxsLCJleHAiOjE3NDg0MTY2MjAsImF1dGhvcml0aWVzIjpbIlJPTEVfVFJVU1RFRF9DTElFTlQiLCJVU0VSIl0sImp0aSI6IjlpVmpDWVRSVFZDckt6M01jLTEtVGJLbGlpRSIsImNsaWVudF9pZCI6IjdWUXJFVlpLMTM5RlljU1p1R092OU8yZiJ9.LKV3FQtyWnv7K6dxwIqD301jIRpejfkmKdiGaSCH9eflpU3b-olFRtDVmlG9paLVOC4X9dZnGbQk2G03Vi1IAT0SqR7TfhqLfkn4_Vy91VwP4ok3VfQcFjl_gLQ2brDQtf_X99Eu6qVHtZM3aXcqGkJfzhh4i7UCXRj8TnWMLZx64zPPrHDpkefuksRZiWGVCQ7I5mw4Y561OTMSSUe-V22nu73iVnQmK21XOIrB1erVKlCzq1HBUkDeST009AQFKEhuvXaNxYYyjRSDf6dJlJ8txfdHKbU379WUJupjr7txgPPkDMhiON19ZXAjB0gV0a5VsDLMOMhKJPjS8w_QFg')
function loadPageVar (sVar) {
  return decodeURI(window.location.href.replace(new RegExp("^(?:.*[&\\?]" + encodeURI(sVar).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}
console.log('路由URL：' + location)
console.log('路由URL参数：' + loadPageVar("access_token"))
if (loadPageVar("access_token")) {
  localStorage.setItem('token',loadPageVar("access_token"))
} else {
  // 看本地是否有token
  if (localStorage.getItem('token')) {
    // 有
  } else {
    // 无
    // 跳转链接地址+自己本地url地址  可能给完后 会跳转回自己本地的url地址
    // if(process.env.NODE_ENV == 'production'){
    //   window.open(process.env.VUE_APP_URL_just+'/boe/urlJump?redirectUrl='+window.location.href)
    // }else{
    // window.open(process.env.VUE_APP_URL_just+'/boe/urlJump?redirectUrl='+window.location.href)
    // window.location.replace(process.env.VUE_APP_URL_just+'/boe/urlJump?redirectUrl='+encodeURIComponent(window.location.href))
    // }
  }
}
const performance = process.env.NODE_ENV !== 'production'
Vue.config.productionTip = false
Vue.config.performance = performance

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
